'use client'

import { useMemo, useState } from "react"
import BrandCard from "./BrandCard"
import { ChevronRight, Search, Tag } from 'lucide-react'
import { resolveColorHex, getVendorPrimaryColor } from "@/utils/util"
import EmptyState from "@/components/elements/EmptyState"

export default function BrandList({ brands, vendor }: { brands: any, vendor?: any }) {
  const primary = resolveColorHex(getVendorPrimaryColor(vendor))
  const vendorName = vendor?.name || 'Дэлгүүр'
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    const list = brands || []
    if (!query.trim()) return list
    const q = query.trim().toLowerCase()
    return list.filter((b: any) => String(b?.name || '').toLowerCase().includes(q))
  }, [brands, query])

  return (
    <div className="bg-white">
      <div className="mx-auto w-full max-w-320 px-4 lg:px-8 py-8">
        <div className="flex items-center gap-1.5 text-[12px] text-muted-foreground mb-8">
          <a href="/" className="hover:text-foreground">Нүүр</a>
          <ChevronRight className="h-3 w-3" />
          <span className="text-foreground font-medium">Брэнд</span>
        </div>

        <div className="flex items-end justify-between gap-6 flex-wrap mb-8">
          <div className="max-w-2xl">
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">
              Брэндүүд
            </h1>
            <p className="mt-2 text-sm text-muted-foreground max-w-xl leading-relaxed">
              {vendorName}-ийн брэндүүдээс дуртайгаа сонгон бүх бүтээгдэхүүнийг нэг дороос үзээрэй.
            </p>
          </div>
          {(brands?.length || 0) > 6 && (
            <div className="flex items-center h-10 px-3.5 gap-2 rounded-full bg-muted border-2 border-transparent focus-within:bg-white focus-within:border-(--brand) transition-colors w-full sm:w-64" style={{ ['--brand' as any]: primary }}>
              <Search className="h-4 w-4 text-muted-foreground shrink-0" />
              <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Брэнд хайх..." className="flex-1 bg-transparent border-0 outline-none text-sm focus:outline-none focus:ring-0 focus:border-0 placeholder:text-muted-foreground" />
            </div>
          )}
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-4">
            {filtered.map((brand: any, index: number) => (
              <BrandCard key={brand.id} brand={brand} index={index} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon={Tag}
            primary={primary}
            title={query ? 'Илэрц олдсонгүй' : 'Брэнд олдсонгүй'}
            description={query ? '"' + query + '" гэсэн нэртэй брэнд олдсонгүй. Өөр түлхүүр үг ашиглан дахин хайна уу.' : 'Яг одоогоор ямар нэгэн брэнд байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу.'}
          />
        )}
      </div>
    </div>
  )
}
